/**
 * Functions related to banner
 *
 * @return void
 *
 */

import {hide, createCookie, body, bannerActiveClass} from "./helpers"

export const banner = () => {
	const bannerEl = document.querySelector('.banner');
	const bannerCloseEl = document.querySelector('.js-banner-close');

	if(bannerEl) {
		body.classList.add(bannerActiveClass);
	}

	function onCloseBanner() {
		hide(bannerEl);
		body.classList.remove(bannerActiveClass);
		createCookie('close_banner', 1);
	}

	if(bannerCloseEl) {
		bannerCloseEl.addEventListener('click', onCloseBanner);
	}
};
